import * as React from 'react'
import { Router } from 'routes'
import firebase from '../../firebase'
import Error from '../../pages/_error'
import * as Sentry from '@sentry/browser'
import { checkIfProfileRegistered, authorizeUser } from 'models/Auth'
import { storeUri } from '../../client/store'
import { login, logout } from 'request'
import { parseCookies } from 'nookies'
import Analytics from 'utils/analytics'

type Scope = 'user' | 'artist' | 'admin'

type Props = {
  authorize: boolean
}
const withAuthorization = (
  defaultAuth = true,
  scope: Scope = 'user'
) => Component => {
  return class WithAuthorization extends React.Component<Props> {
    static displayName = `withAuthorization(${Component.displayName})`

    static getInitialProps = async appCtx => {
      let appProps = { pageProps: {} }
      if (Component.getInitialProps)
        appProps = await Component.getInitialProps(appCtx)

      return {
        ...appProps,
      }
    }

    state = { statusCode: null }

    async componentDidMount() {
      const { authorize } = this.props
      const needsAuthorization =
        authorize === undefined ? defaultAuth : authorize
      storeUri()

      const user = await authorizeUser()

      await this.scopedAuth(needsAuthorization, scope, user)
    }

    async scopedAuth(needsAuthorization, scope, authUser) {
      const { claims = {}, token = '' } = authUser
        ? await authUser.getIdTokenResult()
        : {}
      if (authUser) {
        const { _csrf: csrfToken = '' } = parseCookies()
        login({ idToken: token, csrfToken })
        setUserData(authUser, claims)
      } else logout()

      console.info('withAuthentication', needsAuthorization, scope, authUser)
      const funcs = {
        user: handleUser,
        artist: handleArtist,
        admin: handleAdmin,
      }

      const func = funcs[scope] || funcs['user']
      const { statusCode } =
        (await func(authUser, needsAuthorization, claims)) || {}
      if (statusCode) this.setState({ statusCode })

      return
    }

    public render() {
      const { statusCode } = this.state

      if (statusCode) return <Error statusCode={statusCode} />

      return <Component {...this.props} />
    }
  }
}

function setUserData(user, claims) {
  const userData = { ...user.toJSON(), claims, metadata: user.metadata }

  Sentry.setUser(userData)
  Analytics.identify(user.uid, userData)
}

export default withAuthorization

async function handleUser(authUser, needsAuthorization, claims) {
  if (!authUser) {
    needsAuthorization ? Router.pushRoute('login') : null
    return
  }

  if (
    ((authUser?.providerData as any) || [])
      .filter(d => d.providerId)
      .includes('password') &&
    !authUser?.emailVerified
  ) {
    Router.pushRoute('verifyEmail')
    return
  }
  // プロフィール未入力時、プロフィール画面へ遷移
  if (!claims?.isRegisteredProfile && !(await checkIfProfileRegistered())) {
    Router.pushRoute('registerProfile')
    return
  }

  return
}

async function handleArtist(authUser, needsAuthorization, claims) {
  if (!authUser) {
    needsAuthorization ? Router.pushRoute('artistLogin') : null
    return
  }

  if (!claims?.artist) return { statusCode: 401 }
  return
}

async function handleAdmin(authUser, needsAuthorization, claims) {
  if (!authUser) {
    needsAuthorization ? Router.pushRoute('login') : null
    return
  }

  if (!claims?.admin) return { statusCode: 401 }
  return
}
